import dateFnsGenerateConfig from '@rc-component/picker/es/generate/dateFns'
import { DatePicker as AntDatePicker } from 'antd'
import { type ComponentProps, type FC } from 'react'

const DatePickerDateFns = AntDatePicker.generatePicker<Date>(dateFnsGenerateConfig)

export const DatePicker: FC<ComponentProps<typeof DatePickerDateFns>> = (props) => {
  return <DatePickerDateFns format='DD MMMM, YYYY' {...props} />
}
